<template lang="pug">
  .inactive-subscriptions
    FixedWidthTweakUpper
      .section
        .xs-12
          BackButton(url="/dashboard/purchases")

        .inactive-wrap.xs-12(v-if="inactiveSubs && inactiveSubs.length")
          .title-wrap.xs-12.text-center
            SectionTitle(text="Inactive Subscriptions")

          .subscriptions-wrap.xs-12
            .subscription-wrap.xs-12(v-for="sub in inactiveSubs")
              .xs-12
                p.color-slate.xs-f-xsmall.lg-f-small.max-at-tweak Subscription stopped on {{sub.last_canceled_at | moment("MMM DD, YYYY")}}
              .prod-wrap.xs-12
                ProductInfoImage.xs-4(:imagery="sub.product_info.imagery")

                .prod-info.xs-8.md-4
                  p.upper.bold.xs-f-xsmall.lg-f-small.max-at-tweak {{sub.product_info.product_type_display_name}}
                  p.color-slate.xs-f-xsmall.xs-f-small.max-at-tweak {{sub.product_info.name}}

                .xs-12.md-4
                  router-link.reactivate-cta.mr-btn.btn-block.xs-f-xsmall.max-at-tweak(:to="'/dashboard/purchases/edit-auto-delivery/' + sub.id") reactivate

      ExpertiseIncluded
</template>

<script>
  import { mapGetters } from 'vuex';
  import BackButton from "../../BackButton";
  import SectionTitle from "../../../SectionTitle";
  import ProductInfoImage from '../ProductInfoImage';
  import ExpertiseIncluded from '../../../ExpertiseIncluded';
  import FixedWidthTweakUpper from "../../../FixedWidthTweakUpper";

  export default {
    name: 'InactiveSubscriptions',

    components: {
      FixedWidthTweakUpper,
      BackButton,
      SectionTitle,
      ProductInfoImage,
      ExpertiseIncluded
    },

    computed: {
      ...mapGetters('subscriptions', ['inactiveSubs'])
    },

    beforeCreate() {
      this.$store.dispatch('subscriptions/initSubscriptions');
    }
  }
</script>

<style lang="stylus">
  .inactive-subscriptions
    .title-wrap
      padding-top 1.5em

    .subscriptions-wrap
      .subscription-wrap
        padding 1.5em 0
        border-bottom 1px solid #ccc

        &:last-child
          padding-bottom 0.5em
          border-bottom none

      .prod-wrap
        padding-top 1.5em

        .prod-info
          padding-left 1em

          p
            padding-bottom 0.5em

      .reactivate-cta
        padding-left 1em
        padding-right 1em
        margin-top 1.5em

</style>
